// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".info-label[data-v-2fead0c4] {\n  font-size: 0.775rem;\n  width: 100% !important;\n}\n.fade-enter-active[data-v-2fead0c4] {\n  transition: opacity 0.5s;\n}\n.fade-enter[data-v-2fead0c4],\n.fade-leave-active[data-v-2fead0c4] {\n  transition: opacity 0.15s;\n  opacity: 0;\n}\n.theme--light.history-tab[data-v-2fead0c4] {\n  background-color: #f6f6f6;\n}\n.theme--dark.history-tab[data-v-2fead0c4] {\n  background-color: #273039;\n}", ""]);
// Exports
module.exports = exports;
